import * as httpClients from "../httpClients";

export default class Http {
	constructor(clientName) {
		let client = httpClients.clients[clientName];
		return (auth = false) => {
			client.defaults.baseURL = auth ? window.location.origin : window.endpoints.api;
			return client;
		};
	}
}
